export default __webpack_public_path__ + "static/media/ok_emoji.ce041f1b.png";